import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PipesModule } from "../shared/pipes/pipes.module";
import { ComponentsModule } from '../shared/components/components.module';

import { AdminMsgRoutingModule } from "./admin-msg-routing.module";

import { AdminMsgComponent } from "./admin-msg.component";


@NgModule({
  declarations: [
    AdminMsgComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    ComponentsModule,
    AdminMsgRoutingModule,
  ]
})
export class AdminMsgModule { }
